<template>
    <d-container fluid class="main-content-container px-4">
        <div class="page-header row no-gutters py-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <h3 class="page-title">
                    Connect Network
                </h3>
            </div>
        </div>
        <div v-if="checkPermission(permissionTypes.mediaWrite)">
            <d-row>
                <d-col lg="12">
                    <d-card class="card-small card-post card-post--aside card-post--1">
                        <d-card-body>
                            <h6>
                                Connect your Networks
                            </h6>
                            <p>
                                Connect the networks with your media. In a few steps you will see
                                the transactions in the Ivanhoe dashboard. After you have connected
                                the networks you can connect integrations to Ivanhoe. Press
                                next to see your transactions in Google Analytics.
                            </p>
                        </d-card-body>
                    </d-card>
                </d-col>
            </d-row>
            <d-card class="mt-3 mb-3">
                <d-card-header v-if="$route.name == 'add-network'" class="border-bottom">
                    <d-row class="d-flex justify-content-center">
                        <d-col cols="2" class="progress-text d-none d-xl-block">
                            <h6 class="m-0 text-center bar-text">
                                <d-link class="text-dark" :to="{ name: 'add-domain' }">
                                    1. Add website
                                </d-link>
                            </h6>
                        </d-col>
                        <d-col cols="2" class="progress-text d-none d-xl-block">
                            <h6 class="m-0 text-center bar-text">
                                <d-link class="text-dark" :to="{ name: 'add-network' }">
                                    2. Connect networks
                                </d-link>
                            </h6>
                        </d-col>
                        <d-col cols="2" class="progress-text d-none d-xl-block">
                            <h6 class="m-0 text-center bar-text">
                                3. Connect integrations
                            </h6>
                        </d-col>
                        <d-col cols="2" class="progress-text d-none d-xl-block">
                            <h6 class="m-0 text-center bar-text">
                                4. Place Ivanhoe.io tag
                            </h6>
                        </d-col>
                        <d-col cols="2" class="progress-text d-none d-xl-block">
                            <h6 class="m-0 text-center bar-text">
                                5. Choose direct or cloaked links
                            </h6>
                        </d-col>
                        <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                            <h6 class="m-0 text-center bar-text">
                                6. Ready to start
                            </h6>
                        </d-col>
                    </d-row>
                    <d-progress :value="25" :max="100" />
                </d-card-header>
                <d-card-body>
                    <d-row class="mt-3">
                        <d-col
                            v-for="network in affiliates"
                            :key="network.id"
                            class="mb-4"
                            lg="6"
                            xl="4"
                        >
                            <d-card class="h-100">
                                <d-card-header
                                    :class="{
                                    'border-bottom success': isConnected(network.id),
                                    'border-bottom': !isConnected(network.id)
                                }"
                                >
                                    {{ network.human_readable_name }}
                                </d-card-header>
                                <d-card-body class="d-flex justify-content-center">
                                    <d-col class="d-flex justify-content-center network-img-vertical-center">
                                        <img
                                            class="img-fluid network-img-max-size"
                                            :src="network.logo"
                                            alt="network"
                                        >
                                    </d-col>
                                </d-card-body>

                                <d-card-body v-if="hasReseller(network)" class="d-block justify-content-center card-footer">
                                    <div v-if="getAllConnectedNetworksByAffiliateID(network.id).length > 0">
                                        <p class="mb-2">Connected</p>
                                        <hr class="mt-0">
                                        <div
                                            v-for="(item, index) in getAllConnectedNetworksByAffiliateID(network.id)"
                                            :key="index"
                                            class="d-flex align-items-center"
                                        >
                                            <span
                                                :id="'remove-popup-' + index"
                                                @click="deleteNetwork(item)"
                                                class="material-icons network-remove-icon mr-2"
                                            >
                                                cancel
                                            </span>
                                            <d-tooltip
                                                :target="'#remove-popup-' + index"
                                                container=".shards-demo--example--tooltip-01"
                                            >
                                            <span class="network-tooltip-text">
                                                disconnect {{ item.name }}
                                            </span>
                                            </d-tooltip>
                                            {{ item.name }}
                                        </div>
                                        <hr>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <div v-if="$route.name == 'connect-network'" class="d-flex justify-content-center network-button-mt">
                                            <d-link
                                                tag="button"
                                                :to="{ path: '/connect-network/' + $route.params.id + '/' + network.id }"
                                                class="btn mb-2 mr-1 btn-success"
                                            >
                                                {{ getAllConnectedNetworksByAffiliateID(network.id).length > 0 ? 'Connect another' : 'Connect' }}
                                            </d-link>
                                        </div>
                                        <div v-if="$route.name == 'add-network'" class="d-flex justify-content-center network-button-mt">
                                            <d-link
                                                tag="button"
                                                :to="{ path: '/add-network/connect/' + $route.params.id + '/' + network.id }"
                                                class="btn mb-2 mr-1 btn-success"
                                            >
                                                {{ getAllConnectedNetworksByAffiliateID(network.id).length > 0 ? 'Connect another' : 'Connect' }}
                                            </d-link>
                                        </div>
                                    </div>
                                </d-card-body>
                                <div v-else>
                                    <d-card-footer class="d-flex justify-content-center">
                                        <confirm-message
                                            delete-button-text="Yes, disconnect"
                                            :keep-button-text="`No, keep ${network.human_readable_name}`"
                                            :message="`You are about to disconnect ${network.human_readable_name}`"
                                            @confirm="deleteMedia(network.id)"
                                        >
                                            <button
                                                v-if="isConnected(network.id)"
                                                tag="button"
                                                class="btn mb-2 mr-1 btn-secondary"
                                            >
                                                Disconnect
                                            </button>
                                        </confirm-message>
                                        <div v-if="$route.name == 'connect-network'">
                                            <d-link
                                                v-if="!isConnected(network.id)"
                                                tag="button"
                                                :to="{ path: '/connect-network/' + $route.params.id + '/' + network.id }"
                                                class="btn mb-2 mr-1 btn-success"
                                            >
                                                Connect
                                            </d-link>
                                        </div>
                                        <div v-if="$route.name == 'add-network'">
                                            <d-link
                                                v-if="!isConnected(network.id)"
                                                tag="button"
                                                :to="{ path: '/add-network/connect/' + $route.params.id + '/' + network.id }"
                                                class="btn mb-2 mr-1 btn-success"
                                            >
                                                Connect
                                            </d-link>
                                        </div>
                                    </d-card-footer>
                                </div>
                            </d-card>
                        </d-col>
                    </d-row>
                </d-card-body>
                <d-card-footer v-if="$route.name == 'add-network'">
                    <d-row>
                        <d-col class="d-flex justify-content-start">
                            <d-link
                                tag="button"
                                :to="{ name: 'add-domain' }"
                                class="btn btn-secondary"
                            >
                                Previous step
                            </d-link>
                        </d-col>
                        <d-col class="d-flex justify-content-end">
                            <d-link
                                tag="button"
                                :to="{ name: 'add-intergration', params: { id: websiteId }  }"
                                class="btn btn-success"
                            >
                                Next step
                            </d-link>
                        </d-col>
                    </d-row>
                </d-card-footer>
            </d-card>
        </div>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
    import { AffiliateNetworkService, WebsiteService } from '@/main';
    import notification from '@/mixins/notification';
    import ConfirmMessage from '@/components/common/confirmMessage.vue';
    import permissions from '../../mixins/permissions';

    export default {
        mixins: [notification, permissions],
        components: {
            ConfirmMessage
        },

        data() {
            return {
                affiliates: [],
                mediaIds: [],
                networkId: null,
                websiteId: this.$route.params.id,
                connectedAffiliates: [],
            }
        },

        methods: {
            isConnected(network) {
                let isActive = false
                if (network && this.connectedAffiliates.length > 0) {
                    isActive = this.connectedAffiliates.some((affiliate) => {
                        const affiliateNetwork = affiliate.affiliateNetwork
                        return affiliateNetwork.id === network
                    });
                }
                return isActive
            },

            getAllConnectedNetworksByAffiliateID(id) {
                let connectedNetworks = []
                if (id && this.connectedAffiliates.length > 0) {
                    connectedNetworks = this.connectedAffiliates.filter((affiliate) => {
                        const affiliateNetwork = affiliate.affiliateNetwork
                        return affiliateNetwork.id === id
                    })
                }
                return connectedNetworks
            },

            hasReseller(network) {
                let foundAffiliateNetwork = this.allAffiliateNetworks.find(affiliateNetwork => affiliateNetwork.name === network.name)

                return (foundAffiliateNetwork.config && foundAffiliateNetwork.config.hasOwnProperty('has_resellers') && foundAffiliateNetwork.config.has_resellers)
                ? true
                : false
            },

            async getMediaIds() {
                try {
                    this.mediaIds = await AffiliateNetworkService.getMediaIds(this.$route.params.id)
                    await this.getConnectedAffiliates()
                } catch (error) {
                    this.showNotification('warn', 'We have a problem', 'Oops! can not get medias')
                    console.log(error)
                }
            },

            async getConnectedAffiliates() {
                try {
                    this.connectedAffiliates = await AffiliateNetworkService.getNetworks(this.$route.params.id, this.mediaIds)
                } catch (error) {
                    this.showNotification('warn', 'We have a problem', 'Oops! can not get affiliates')
                    console.log(error)
                }
            },

            async getAffiliates() {
                try {
                    this.affiliateArray = await AffiliateNetworkService.getByStatusId(1)

                    this.activeAffiliatesSorted = []
                    this.inactiveAffiliatesSorted = []

                    this.affiliateArray.forEach((item) => {
                        this.isConnected(item.id) ? this.activeAffiliatesSorted.push(item) : this.inactiveAffiliatesSorted.push(item)
                    });

                    this.activeAffiliatesSorted.sort(function (a, b) {
                        if (a.human_readable_name === b.human_readable_name) return 0
                        return a.human_readable_name > b.human_readable_name ? 1 : -1
                    })
                    
                    this.inactiveAffiliatesSorted.sort(function (a, b) {
                        if (a.human_readable_name === b.human_readable_name) return 0
                        return a.human_readable_name > b.human_readable_name ? 1 : -1
                    })

                    this.sortedAffiliates = [...this.activeAffiliatesSorted, ...this.inactiveAffiliatesSorted]
                    
                    this.affiliates = this.sortedAffiliates
                    
                } catch (error) {
                    this.showNotification('success', 'We have a problem', 'Oops! can not get affiliates')
                    console.log(error)
                }
            },

            async deleteNetwork(network) {
                try {
                    await AffiliateNetworkService.delete(this.$route.params.id, network.id)
                    this.showNotification('success', 'Alert', `${network.name} successfully removed!`)
                    this.$router.go()
                } catch (error) {
                    this.showNotification('warn', 'We have a problem', 'Oops! something went wrong')
                    console.log(error)
                }
            },

            async deleteMedia(networkId) {
                const affiliates = await AffiliateNetworkService.getCredentials(this.$route.params.id, this.mediaIds, networkId)
                try {
                    await AffiliateNetworkService.delete(this.$route.params.id, affiliates.id)
                    this.showNotification('success', 'Alert', 'Network successfully removed!')
                    this.$router.go()
                } catch (error) {
                    this.showNotification('warn', 'We have a problem', 'Oops! something went wrong')
                    console.log(error)
                }
            },

            async getAllAffiliates() {
                try {
                    this.allAffiliateNetworks = await AffiliateNetworkService.getByStatusId(1)
                } catch (error) {
                    this.showNotification('warn', 'We have a problem', 'Oops! can not get affiliates')
                    console.log(error)
                }
            },


            async onPageInit() {
                await this.getAllAffiliates()
                await this.getMediaIds()
                await this.getAffiliates()
            }
        },

        created() {
            this.onPageInit()
        },
    }
</script>
